import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { PawPrint } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import { ADMIN } from "@/constants/testIds";

export default function AdminLogin() {
  const [email, setEmail] = useState("admin@raijadakennel.com");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const formatErr = (detail) => {
    if (detail == null) return "Something went wrong. Please try again.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
    return String(detail);
  };

  const submitCredentials = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatErr(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0F2520] flex items-center justify-center px-6">
      <form
        onSubmit={submitCredentials}
        className="w-full max-w-sm bg-[#16332C] border border-[#234B41] rounded-[1.5rem] p-8"
      >
        <div className="flex items-center gap-2 mb-8">
          <PawPrint className="w-7 h-7 text-[#F4D06F]" />
          <span className="font-display text-xl font-bold text-[#F9F8F6]">Raijada Admin</span>
        </div>
        {error && (
          <p data-testid={ADMIN.loginError} className="text-sm text-red-400 mb-4">
            {error}
          </p>
        )}

        <div className="space-y-4">
          <Input
            data-testid={ADMIN.loginEmail}
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="h-12 rounded-xl bg-[#0F2520] border-[#234B41] text-[#F9F8F6]"
          />
          <Input
            data-testid={ADMIN.loginPassword}
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="h-12 rounded-xl bg-[#0F2520] border-[#234B41] text-[#F9F8F6]"
          />
          <Button
            data-testid={ADMIN.loginSubmit}
            type="submit"
            disabled={loading}
            className="w-full h-12 rounded-full bg-[#D97736] hover:bg-[#F4D06F] hover:text-[#0F2520] text-white font-semibold"
          >
            {loading ? "Signing in..." : "Sign In"}
          </Button>
        </div>
      </form>
    </div>
  );
}
